<template>
    <div class="edit-info-result__content">
        <div class="edit-info-result__status"
             :class="{'edit-info-result__success':resultStatus,'edit-info-result__fail':!resultStatus}"
        ></div>

        <p class="edit-info-result__title">{{resultStatus?t('updateTip.editForm.submit_success'):t('updateTip.editForm.submit_fail')}}</p>

        <p class="edit-info-result__tip">{{resultStatus?t('updateTip.editForm.success_sub'):t('updateTip.editForm.fail_sub')}}</p>

        <div flex="o" class="edit-info-result__footer">
            <button class="th-btn" @click="cancelEditResult">
                {{t('updateTip.editForm.got_it')}} ({{initTimer}}s)
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const emits = defineEmits<{
    (e: 'cancel'): void,
}>()

function cancelEditResult() {
    emits('cancel')
}

defineProps<{
    resultStatus: boolean
}>()

const initTimer = ref(5)

onMounted(() => {
    setInterval(() => {
        if (initTimer.value <= 0) return
        initTimer.value--;
        if (initTimer.value === 0) {
            cancelEditResult();
        }
    }, 1000)
})
</script>

<style lang="scss">
.edit-info-result__content {
    padding: 36px 60px 60px;
    color: $text-primary;
}
.edit-info-result__status {
    background-repeat: no-repeat;
    background-size: cover;
    width: 58px;
    height: 58px;
    margin: auto;
    margin-bottom: 24px;
}
.edit-info-result__success {
    background-image: url('../assets/icon/success.svg');
}
.edit-info-result__fail {
    background-image: url('../assets/icon/fail.svg');
}
.edit-info-result__title {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    line-height: 28px;
}
.edit-info-result__tip {
    font-size: 14px;
    color: $text-hint;
    margin: 24px 0;
    text-align: center;
}
.edit-info-result__footer {
    margin-top: 40px;
}
</style>
